<template>
  <div>
    <b-row>
      <b-col md="3">
        <b-form-group
          label="Cheque Number Range"
        >
          <b-row>
            <b-col cols="6">
              <b-form-input
                v-model.number="chequeNumberMin"
                type="number"
                min="0"
                max="999999"
                placeholder="Min"
                @input="debouncedFiltersChange"
              />
            </b-col>
            <b-col cols="6">
              <b-form-input
                v-model.number="chequeNumberMax"
                type="number"
                min="0"
                max="999999"
                placeholder="Max"
                @input="debouncedFiltersChange"
              />
            </b-col>
          </b-row>
        </b-form-group>
      </b-col>
      <b-col md="3">
        <b-form-group
          label="Amount Range"
        >
          <b-row>
            <b-col cols="6">
              <b-form-input
                v-model.number="amountMin"
                type="number"
                min="0"
                max="1000000"
                step="1000"
                placeholder="Min Amount"
                @input="debouncedFiltersChange"
              />
            </b-col>
            <b-col cols="6">
              <b-form-input
                v-model.number="amountMax"
                type="number"
                min="0"
                max="1000000"
                step="1000"
                placeholder="Max Amount"
                @input="debouncedFiltersChange"
              />
            </b-col>
          </b-row>
        </b-form-group>
      </b-col>
      <b-col md="2">
        <b-form-group
          label="Supplier"
        >
          <custom-v-select
            id="party"
            v-model="selectedParties"
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            :options="partyOptions"
            label="text"
            placeholder="Select Supplier"
            :close-on-select="false"
            :deselect-from-dropdown="true"
            @input="filtersChangeHandler"
          />
        </b-form-group>
      </b-col>
      <b-col md="2">
        <b-form-group
          label="Salesman"
          label-for="salesman"
        >
          <custom-v-select
            id="salesman"
            v-model="selectedSalesmans"
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            :options="salesmanOptions"
            label="text"
            placeholder="Select Salesman"
            :close-on-select="false"
            :deselect-from-dropdown="true"
            @input="filtersChangeHandler"
          />
        </b-form-group>
      </b-col>
      <b-col md="2">
        <b-form-group
          label="Area"
          label-for="area"
        >
          <custom-v-select
            id="area"
            v-model="selectedAreas"
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            :options="areaOptions"
            label="text"
            multiple
            placeholder="Select Area"
            :close-on-select="false"
            :deselect-from-dropdown="true"
            @input="filtersChangeHandler"
          />
        </b-form-group>
      </b-col>
      <b-col md="3">
        <b-form-group
          label="Issue Date Range"
        >
          <flat-picker
            v-model="chequeDateRange"
            placeholder="Select Date Range"
            :config="{ mode: 'range'}"
          />
        </b-form-group>
      </b-col>
      <b-col md="3">
        <b-form-group
          label="Deposited On Date Range"
        >
          <flat-picker
            v-model="depositedOnDateRange"
            placeholder="Select Date Range"
            :config="{ mode: 'range'}"
          />
        </b-form-group>
      </b-col>
      <b-col md="2">
        <b-form-group
          label="Status"
        >
          <custom-v-select
            v-model="selectedStatusOption"
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            :options="statusOptions"
            label="text"
            placeholder="Select Option"
            @input="filtersChangeHandler"
          />
        </b-form-group>
      </b-col>
      <b-col md="2">
        <b-form-group
          label="Sent Through"
        >
          <custom-v-select
            v-model="selectedSendThroughOption"
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            :options="sendThroughOptions"
            label="text"
            placeholder="Select Option"
            @input="filtersChangeHandler"
          />
        </b-form-group>
      </b-col>
      <b-col md="2">
        <b-form-group
          label="Docket Number"
        >
          <b-form-input
            v-model="docketNumber"
            type="text"
            placeholder="Docket Number"
            @input="debouncedFiltersChange"
          />
        </b-form-group>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import {
  VBTooltip, BRow, BCol, BFormGroup, BFormInput,
} from 'bootstrap-vue'
import axios from 'axios'
import CustomVSelect from '@/components/UI/CustomVSelect.vue'
import FlatPicker from '@/components/UI/FlatPicker.vue'

export default {
  directives: {
    'b-tooltip': VBTooltip,
  },
  components: {
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    CustomVSelect,
    FlatPicker,
  },
  data() {
    return {
      partyOptions: [],
      selectedParties: [],
      chequeNumberMin: null,
      chequeNumberMax: null,
      amountMin: null,
      amountMax: null,
      docketNumber: null,
      debounceTimer: null,
      areaOptions: [],
      selectedSendThroughOption: [],
      selectedStatusOption: [],
      selectedAreas: [],
      salesmanOptions: [],
      selectedSalesmans: [],
      statusOptions: [
        { text: 'Undeposited', value: 'undeposited' },
        { text: 'Deposited', value: 'deposited' },
        { text: 'Cancelled', value: 'cancelled' },
        { text: 'Bounced', value: 'bounced' },
        { text: 'Security', value: 'security' },
      ],
      sendThroughOptions: [
        { text: 'MR', value: 'MR' },
        { text: 'Courier', value: 'courier' },
      ],
      receivedDateRange: null,
      chequeDateRange: null,
      depositedOnDateRange: null,
    }
  },
  computed: {
    chequeRangeStyle() {
      const min = 0
      const max = 999999
      const minPercent = ((this.chequeNumberMin - min) / (max - min)) * 100
      const maxPercent = ((this.chequeNumberMax - min) / (max - min)) * 100
      return {
        left: `${minPercent}%`,
        width: `${maxPercent - minPercent}%`,
      }
    },
    amountRangeStyle() {
      const min = 0
      const max = 1000000
      const minPercent = ((this.amountMin - min) / (max - min)) * 100
      const maxPercent = ((this.amountMax - min) / (max - min)) * 100
      return {
        left: `${minPercent}%`,
        width: `${maxPercent - minPercent}%`,
      }
    },
  },
  watch: {
    receivedDateRange(newValue) {
      if (newValue) {
        const [fromDate, toDate] = newValue.split(' to ')
        if (fromDate && toDate) {
          this.filtersChangeHandler()
        }
      } else if (newValue === '') {
        this.filtersChangeHandler()
      }
    },
    chequeDateRange(newValue) {
      if (newValue) {
        const [fromDate, toDate] = newValue.split(' to ')
        if (fromDate && toDate) {
          this.filtersChangeHandler()
        }
      } else if (newValue === '') {
        this.filtersChangeHandler()
      }
    },
    depositedOnDateRange(newValue) {
      if (newValue) {
        const [fromDate, toDate] = newValue.split(' to ')
        if (fromDate && toDate) {
          this.filtersChangeHandler()
        }
      } else if (newValue === '') {
        this.filtersChangeHandler()
      }
    },
  },
  created() {
    this.fetchOptions()
  },
  beforeDestroy() {
    // Clean up timer when component is destroyed
    if (this.debounceTimer) {
      clearTimeout(this.debounceTimer)
    }
  },
  methods: {
    debouncedFiltersChange() {
      // Clear the existing timer
      if (this.debounceTimer) {
        clearTimeout(this.debounceTimer)
      }

      // Set a new timer
      this.debounceTimer = setTimeout(() => {
        this.filtersChangeHandler()
      }, 500) // 500ms delay
    },
    formatChequeNumber(value) {
      return String(value).padStart(6, '0')
    },
    formatAmount(value) {
      return new Intl.NumberFormat('en-IN').format(value)
    },
    fetchOptions() {
      axios.get('/supplier_options')
        .then(res => {
          this.partyOptions = res.data.data
        })

      axios.get('/accounts/areas_options')
        .then(res => {
          this.areaOptions = res.data.data
        })

      axios.get('/accounts/salesmans_options')
        .then(res => {
          this.salesmanOptions = res.data.data
        })
    },
    filtersChangeHandler() {
      const filtersdata = {}
      if (this.selectedParties) {
        filtersdata.supplier = this.selectedParties.id
      }

      if (this.selectedAreas.length > 0) {
        filtersdata.area = this.selectedAreas.map(item => item.id)
      }

      if (this.selectedSalesmans) {
        filtersdata.delivery_boy_id = this.selectedSalesmans.id
      }

      if (this.selectedStatusOption) {
        filtersdata.status = this.selectedStatusOption.value
      }

      if (this.selectedSendThroughOption) {
        filtersdata.sent_through = this.selectedSendThroughOption.value
      }

      if (this.chequeDateRange) {
        const [chequeDateFrom, chequeDateTo] = this.chequeDateRange.split(' to ')
        if (chequeDateFrom && chequeDateTo) {
          filtersdata.issue_date_from = chequeDateFrom
          filtersdata.issue_date_to = chequeDateTo
        }
      }

      if (this.depositedOnDateRange) {
        const [depositedDateFrom, depositedDateTo] = this.depositedOnDateRange.split(' to ')
        if (depositedDateFrom && depositedDateTo) {
          filtersdata.deposited_on_from = depositedDateFrom
          filtersdata.deposited_on_to = depositedDateTo
        }
      }

      // Handle cheque number range
      if (this.chequeNumberMin !== null || this.chequeNumberMax !== null) {
        if (this.chequeNumberMin !== null) {
          filtersdata.cheque_number_min = this.chequeNumberMin
        }
        if (this.chequeNumberMax !== null) {
          filtersdata.cheque_number_max = this.chequeNumberMax
        }
      }

      // Handle amount range
      if (this.amountMin !== null || this.amountMax !== null) {
        if (this.amountMin !== null) {
          filtersdata.min_amount = this.amountMin
        }
        if (this.amountMax !== null) {
          filtersdata.max_amount = this.amountMax
        }
      }

      if (this.docketNumber) {
        filtersdata.docket_number = this.docketNumber
      }

      this.$emit('filtersUpdated', filtersdata)
    },
  },
}
</script>
